<template>
    <div :class="s.sign">
        <p v-if="!subcontactsView">Чтобы поставщики могли направить вам актуальные предложения, система создаст запросы коммерческих предложений.</p>
        <div :class="s.signContainer">
            <div :class="s.signTextPlace">
                <p>Зарегистрируйтесь, чтобы создать новый запрос</p>
                <div :class="s.signImage">
                    <user-project-img />
                </div>
            </div>
            <div :class="s.signWidgetPlace">
                <sigh-header @change-state="operation = $event" :class="s.signHeader" :state="operation" />
                <div :class="s.signWidgetContainer">
                    <template v-if="operation == 'reg'">
                        <registration :widget-data="widgetData" :theme="theme" :text="text" :target="target"
                            :actionParams="actionParams"
                            :no-success-modal="noSuccessModal"
                            :note="registrationNote"
                            @changeState="changeState"
                            @registered="onAuthenticated(true)" />
                    </template>
                    <template v-else>
                        <login
                            :class="s.signLogin"
                            :widget-data="widgetData"
                            :theme="theme" :text="text"
                            :target="target"
                            :actionParams="actionParams"
                            :autoInit="autoInit"
                            :note="loginNote"
                            @changeState="changeState"
                            @logged="onAuthenticated(false)" />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import registration from './registration/registration'

    import login from './login/login'

    import sighHeader from './sign-header/sign-header.vue'
    import userProjectImg from './images/user-project-img.vue'

    import style from './style.module.scss'

    import { getWidgetAny } from './onboarding.js'

    export default {
        name: 'sign',
        components: {
            registration,
            login,
            sighHeader,
            userProjectImg
        },
        props: {
            theme: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: ''
            },
            target: {
                type: String,
                default: '_self'
            },
            actionParams: {
                type: Object,
                default() {
                    return null;
                }
            },
            propsWidgetData: {
                type: Object,
                default: () => {
                    return null;
                }
            },
            noSuccessModal: {
                type: Boolean,
                required: false,
                default: false
            },
            loginNote: {
                type: String,
                required: false
            },
            registrationNote: {
                type: String,
                required: false
            },
            subcontactsView: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                s: style,
                operation: 'login',
                autoInit: {
                    type: Object,
                    login: null,
                    message: null,
                },
                onboardingInfo: {
                    touchpointType: "SITE",
                    touchpointCode: "OPEN_MAIN",
                    magnetCode: undefined
                },
                widgetData: {}
            }
        },
        created() {
            if (window.eventBus) {
                window.eventBus.$on('widget-auth-change-state', this.changeState);
            }
            if (window.location.search.indexOf('rfeg=') > 0) {
                const query = this.parseUrlQuery();
                if (query && query.rfeg) {
                    const cookie = this.getCookie(query.rfeg);
                    if (cookie) {
                        const data = decodeURIComponent(cookie).split('|');
                        this.autoInit.login = data[0];
                        this.autoInit.message = data[2];
                        this.operation = 'log';
                    }
                }
            }
        },
        mounted() {
            if(this.propsWidgetData != undefined && this.propsWidgetData != null){
                this.widgetData = this.propsWidgetData
            } else {
                getWidgetAny(this.onboardingInfo.magnetCode, this.onboardingInfo.touchpointType, this.onboardingInfo.touchpointCode)
                .then(data => {
                    if (!data.isSuccess) {
                        console.log('произошла ошибка -', data.errorMessage)
                        return false;
                    }
                    if (data.widgets && data.widgets.length > 0) {
                        this.widgetData = data.widgets[0];
                    }
                })
                .catch(error => {
                    console.log(error)
                });
            }

        },
        beforeDestroy() {
            if (window.eventBus) {
                window.eventBus.$off('widget-auth-change-state', this.changeState);
            }
        },
        methods: {
            changeState(stateName) {
                this.operation = stateName
            },
            parseUrlQuery() {
                const data = {};
                if (window.location.search) {
                    const pair = (window.location.search.substr(1)).split('&');
                    for (let i = 0; i < pair.length; i++) {
                        const param = pair[i].split('=');
                        data[param[0]] = param[1];
                    }
                }
                return data;
            },
            getCookie(name) {
                const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                if (match) return match[2];
            },
            onAuthenticated(isNewUser) {
                this.$emit('authenticated', isNewUser);
            }
        }
    }
</script>